(function () {

  'use strict';

  function pxDestinationMicrosoftOneDrive(RegexModel) {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        workflowForm: '=',
        workflowFormModel: '=',
        fileNameShorthands: '=',
        fileNameFormModel: '=',
        filePathFormModel_ONEDRIVE: '=filePathFormModelOnedrive'
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/destination/microsoftOneDrive/destinationMicrosoftOneDrive.template.html',
      link: function (scope, element, attrs) {

        scope.BAD_FILE_NAME = new RegexModel().badNameString_variables().string;
        scope.BAD_PATH_STRING = new RegexModel().badPathString_variables().string;

      }
    };
  }

  pxDestinationMicrosoftOneDrive.$inject = ['RegexModel'];

  angular
    .module('printix-admin')
    .directive('pxDestinationMicrosoftOneDrive', pxDestinationMicrosoftOneDrive);

})();
